import { Box, type BoxProps } from "@chakra-ui/react";

import { nvpTokens } from "@/design-system/tokens";

export function NvpWordmark(props: BoxProps) {
  const logo = nvpTokens.brand.logo;

  return (
    <Box
      as="svg"
      viewBox="0 0 132 72"
      role="img"
      aria-label="NVP Games"
      w={logo.wordmarkWidth}
      h={logo.wordmarkHeight}
      filter={`drop-shadow(${logo.shadow})`}
      flex="0 0 auto"
      {...props}
    >
      <g fontFamily="'Lilita One', Inter, ui-sans-serif, sans-serif" fontWeight="900">
        <text
          x="7"
          y="43"
          fill={logo.white}
          fontSize="45"
          letterSpacing="0"
          transform="rotate(-3 24 24)"
        >
          N
        </text>
        <text
          x="47"
          y="43"
          fill={logo.pink}
          fontSize="45"
          letterSpacing="0"
          transform="rotate(2 62 24)"
        >
          V
        </text>
        <g transform="rotate(6 100 24)">
          <text
            x="86"
            y="43"
            fill={logo.yellow}
            fontSize="44"
            letterSpacing="0"
          >
            P
          </text>
          <path
            fill={logo.starCutout}
            d="M99.1 17.1 100.9 21l4.3.4-3.3 2.8 1 4.2-3.8-2.2-3.8 2.2 1-4.2-3.3-2.8 4.3-.4 1.8-3.9Z"
          />
        </g>
      </g>

      <text
        x="65"
        y="65"
        fill={logo.gamesFill}
        fontFamily="Inter, ui-sans-serif, system-ui, sans-serif"
        fontSize="19"
        fontWeight="900"
        letterSpacing="9"
        textAnchor="middle"
      >
        GAMES
      </text>
    </Box>
  );
}
